module.exports = __webpack_public_path__ + "bower_components/ngWYSIWYG/dist/images/icons.png";


/*****************
 ** WEBPACK FOOTER
 ** ./bower_components/ngWYSIWYG/dist/images/icons.png
 ** module id = 17
 ** module chunks = 1
 **/